module.exports = __webpack_public_path__ + "static/media/sponcer_NIQ.e2fd7f5d.png";